import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import ListingItem from './listing_item'
import PromotedProperties from './promoted_properties'
import { appendToRef, getPropertyTypeTitle, validate } from './utils'
import { SORT_TYPE } from '../../common/constants/classifications'
import './listings.scss'
import { withNamespaces, Trans } from "react-i18next"
import { compose } from 'redux'
import CouponHelper from '../../common/helpers/coupon_helper'

export class Listings extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ...props.query
    }
  }

  componentDidMount() {
    this.appendFooter()
  }

  static get areaSelectorContainer() {
    return (this._areaSelectorContainer = this._areaSelectorContainer || document.querySelector('.js-area-selector-container'))
  }

  appendFooter() {
    if (this.props.match.params.prefecture) {
      appendToRef(this.refs.areaSelectorSlot, Listings.areaSelectorContainer)
    }
  }

  get canSortByDistance() {
    return this.props.spotId || this.props.query.destination
  }

  get title() {
    const { search: { coupon }, place: { key, value, propertyTypes }, lang } = this.props
    const propertyTypeTitle = getPropertyTypeTitle(propertyTypes, { coupon })
    if (lang === 'ja') {
      switch (key) {
      case 'featureTitle':
        return <span>{value}</span>
      case 'destination':
        return (
          <React.Fragment>
            <span>{value}周辺の</span>
            <span className="notranslate">{propertyTypeTitle['ja']}</span>
          </React.Fragment>
        )
      case 'area':
      case 'prefecture':
        return (
          <React.Fragment>
            <span>{value}の</span>
            <span className="notranslate">{propertyTypeTitle['ja']}</span>
          </React.Fragment>
        )
      default:
        if (coupon) {
          return (
            <React.Fragment>
              <span className="notranslate">{propertyTypeTitle['ja']}</span>
            </React.Fragment>
          )
        }
        return (
          <React.Fragment>
            <span className="notranslate">{this.props.countryName || '全国'}の{propertyTypeTitle['ja']}</span>
          </React.Fragment>
        )
      }
    }

    if (lang === 'zh-TW') {
      return this.titleZhTw
    }

    if (!propertyTypeTitle['en']) {
      // 英語でかつ建物タイプ検索しない場合
      switch (key) {
      case 'featureTitle':
        return <span>{value}</span>
      case 'destination':
        return <span>Accommodations near {value}</span>
      case 'area':
      case 'prefecture':
        return <span>Accommodations in {value}</span>
      default:
        return <span>Accommodations in {this.props.countryName || 'Japan'}</span>
      }
    }

    switch (key) {
    case 'featureTitle':
      return <span>{value}</span>
    case 'destination':
      return (
        <React.Fragment>
          <span className="notranslate">{`${propertyTypeTitle['en']} `}</span>
          <span>near {value}</span>
        </React.Fragment>
      )
    case 'area':
    case 'prefecture':
      return (
        <React.Fragment>
          <span className="notranslate">{`${propertyTypeTitle['en']} `}</span>
          <span>in {value}</span>
        </React.Fragment>
      )
    default:
      return <span className="notranslate">{propertyTypeTitle['en']} in {this.props.countryName || 'Japan'}</span>
    }
  }

  get titleZhTw() {
    const { place: { key, value } } = this.props
    switch (key) {
    case 'featureTitle':
      return <span>{value}</span>
    case 'destination':
      return <span>{value}附近的住宿</span>
    case 'area':
    case 'prefecture':
      return <span>{value}的住宿</span>
    default:
      return <span>{this.props.countryName || '日本'}的住宿</span>
    }
  }

  /**
   * ソートのリストをrenderする
   */
  renderOrderList() {
    const { sort } = validate({ ...this.props.match.params, ...this.props.query })
    const { t } = this.props
    return (
      <ul styleName="sort-list">
        { this.canSortByDistance &&
          <li styleName="sort-list-item">
            <Link
              to={this.props.searchPath({ sort: this.spotId ? undefined : SORT_TYPE.DISTANCE_ASC })}
              styleName={`sort-list-label${sort == SORT_TYPE.DISTANCE_ASC || (!sort && this.spotId) ? ' current' : ''}`}
            >
              <span>{t('search.result.filter.distance_1')}</span><span>{t('search.result.filter.distance_2')}</span>
            </Link>
          </li>
        }
        <li styleName="sort-list-item">
          <Link
            to={this.props.searchPath({ sort: this.props.spotId ? SORT_TYPE.SIZE_DESC : undefined })}
            styleName={`sort-list-label${sort == SORT_TYPE.SIZE_DESC || (!sort && !this.props.spotId) ? ' current' : ''}`}
          >
            <span>{t('search.result.filter.size_1')}</span><span>{t('search.result.filter.size_2')}</span>
          </Link>
        </li>
        <li styleName="sort-list-item">
          <Link
            to={this.props.searchPath({ sort: SORT_TYPE.PRICE_ASC })}
            styleName={`sort-list-label${sort == SORT_TYPE.PRICE_ASC ? ' current' : ''}`}
          >
            <span>{t('search.result.filter.price_low_1')}</span><span>{t('search.result.filter.price_low_2')}</span>
          </Link>
        </li>
        <li styleName="sort-list-item">
          <Link
            to={this.props.searchPath({ sort: SORT_TYPE.PRICE_DESC })}
            styleName={`sort-list-label${sort == SORT_TYPE.PRICE_DESC ? ' current' : ''}`}
          >
            <span>{t('search.result.filter.price_high_1')}</span><span>{t('search.result.filter.price_high_2')}</span>
          </Link>
        </li>
      </ul>
    )
  }

  /**
   * ページネーション関連情報を返す
   */
  get paginationInfo() {
    const {
      search: {
        room_groups: roomGroups,
        offset,
        total_count: total,
        limit
      },
      query: { page = 1 }
    } = this.props

    const from = offset + (roomGroups.length && 1)
    const to = offset + roomGroups.length
    const totalPages = Math.ceil(total / limit)
    return { page, from, to, total, totalPages }
  }

  /**
   * 表示件数のNodeをrenderする
   */
  renderCounterNode() {
    const { from, to, total } = this.paginationInfo
    const label = from == to ? from : `${from}-${to}`

    if (!total || !this.props.search.isFetched) return

    return (
      <p styleName="search-result-count">
        <span>
          <Trans i18nKey='search.paging' total={total} label={label} >
            <span className="notranslate" styleName="number">{{total}}</span>件中
            <span className="notranslate" styleName="number">{{label}}</span>件を表示
          </Trans>
        </span>
      </p>
    )
  }

  /**
   * ページネーションをrenderする
   */
  renderPagination() {
    const { page, total, totalPages } = this.paginationInfo
    const { limit, isFetched } = this.props.search

    // 2ページ目がない場合は表示しない
    if (!isFetched || total <= limit) return

    return (
      <ReactPaginate
        pageCount={totalPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        previousLabel=""
        nextLabel=""
        breakLabel={<div className="search-pager-list-abridgement">&hellip;</div>}
        containerClassName="search-pager-list-wrap notranslate"
        breakClassName="search-pager-list passive-abridgement"
        pageClassName="search-pager-list"
        previousClassName="search-pager-list search-pager-prev"
        nextClassName="search-pager-list search-pager-next"
        pageLinkClassName="search-pager"
        previousLinkClassName="search-pager search-pager-prev-inner"
        nextLinkClassName="search-pager search-pager-next-inner"
        activeClassName="active"
        hrefBuilder={(page) => this.props.searchPath({ page: (page > 1 ? page : undefined) })}
        initialPage={page - 1}
        disableInitialCallback={true}
        onPageChange={({ selected }) => this.props.onPageChange({ page: (selected ? selected + 1 : undefined) })}
      />
    )
  }

  /**
   * 優先表示枠の表示
   */
  renderPromotedListings() {
    const {
      lang,
      propertyTypes,
      search: { isSP }
    } = this.props

    return <PromotedProperties
      isSP={isSP}
      lang={lang}
      propertyTypes={propertyTypes}
      searchParams={{
        ...this.props.match.params,
        ...this.props.query
      }}
    />
  }

  /**
   * リスティング一覧の表示
   */
  renderListings() {
    const {
      lang,
      propertyTypes,
      search: {
        room_groups: roomGroups,
        isFetched,
        isSP
      },
      query: {
        destination,
        checkin,
        checkout,
        adults,
        rooms
      },
      t
    } = this.props

    if (!isFetched) return null

    if (!roomGroups.length) {
      return (
        <div className="search-result-empty-message">
          { t('search.result.empty_message') }
        </div>
      )
    }

    return roomGroups.map((roomGroup) => {
      return <ListingItem key={roomGroup.id}
        lang={lang}
        { ...roomGroup.property }
        { ...roomGroup }
        property_type={propertyTypes[roomGroup.property.property_type]}
        checkin={checkin}
        checkout={checkout}
        adults={adults}
        rooms={rooms}
        destination={destination}
        isSP={isSP}
        lang={lang}
      />
    })
  }

  /**
   * タイトルをrenderする
   */
  renderTitle() {
    return (
      <header className="notranslate" styleName="search-condition-header">
        <h1 styleName="search-condition-title" id="search-condition-title">
          { this.props.featureURL
            ? <a href={this.props.featureURL} target="_blank">{this.title}</a>
            : this.title
          }
          {this.renderSearchCounter()}
        </h1>
      </header>
    )
  }

  renderSearchCounter() {
    const count = this.props.search.total_count
    let preText = ' ('
    let counterText = ''
    switch (this.props.lang) {
    case 'ja':
      counterText = '件)'
      break
    case 'zh-TW':
      preText = ' (找到'
      counterText = '個住宿)'
      break
    default:
      counterText = ` accommodation${count > 1 ? 's' : ''} found)`
      break
    }
    return (
      <div styleName="search-condition-counter">
        <span className="notranslate">{preText}</span>
        <span className="notranslate">{count}</span>
        <span>{counterText}</span>
      </div>
    )
  }

  renderCouponCheckBox() {
    const couponIds = [].concat(
      this.state.coupon_id || []
    )

    return (
      this.props.coupons && this.props.coupons.map(coupon => (
        <div key={coupon.id} styleName="coupon-checkbox">
          <input
            id="coupon-checkbox"
            type="checkbox"
            styleName=""
            value={coupon.id.toString()}
            onChange={ ({ target: { value } }) => {
              this.props.onSubmitForm({
                coupon_id: couponIds.includes(coupon.id.toString()) ? [] : [value]
              })
            }}
            checked={couponIds.includes(coupon.id.toString())}
          />
          <label styleName="" htmlFor='coupon-checkbox'>
            { CouponHelper.translateName(coupon.title, this.props.lang, 'search_condition') }
          </label>
        </div>
      ))
    )
  }

  renderBanner() {
    return (
      <div style={{ marginTop: 32 }}>
        <a styleName="banner sp" href="/rakuten-stay">
          <img src="/assets/image/banner/banner-rs-all-sp2.jpg" alt="" />
        </a>
        <a styleName="banner sp" href="https://experiences.travel.rakuten.co.jp/?scid=wi_oyd_search-banner" target="_blank" rel="noreferrer noopener">
          <img src="/assets/image/banner/RTE-600x120.png" alt="" />
        </a>
      </div>
    )
  }

  render() {
    const { t } = this.props
    return (
      <section styleName="listings">
        {this.props.children}
        {this.renderTitle()}
        {this.renderOrderList()}
        {this.renderCouponCheckBox()}
        {this.renderPromotedListings()}
        {this.renderListings()}
        {this.renderCounterNode()}
        {this.renderPagination()}
        {this.renderBanner()}
        <div ref="areaSelectorSlot"></div>
      </section>
    )
  }
}

Listings.propTypes = {
  lang: PropTypes.string.isRequired,
  propertyTypes: PropTypes.object.isRequired,
  match: PropTypes.shape({
    isExact: PropTypes.bool.isRequired,
    params: PropTypes.object,
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }).isRequired,
  search: PropTypes.shape({
    total_count: PropTypes.number.isRequired,
    room_groups: PropTypes.array.isRequired,
    offset: PropTypes.number.isRequired,
    isFetched: PropTypes.bool.isRequired,
    limit: PropTypes.number.isRequired
  }),
  query: PropTypes.shape({
    destination: PropTypes.string,
    prefecture: PropTypes.string,
    sort: PropTypes.string.isRequired,
    checkin: PropTypes.string,
    checkout: PropTypes.string,
    adults: PropTypes.string,
    rooms: PropTypes.array
  }),
  onPageChange: PropTypes.func.isRequired,
  place: PropTypes.shape({
    key: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    propertyTypes: PropTypes.any
  }),
  searchPath: PropTypes.func.isRequired,
  featureURL: PropTypes.string,
  spotId: PropTypes.string,
  children: PropTypes.node.isRequired,
  countryName: PropTypes.string
}

Listings.defaultProps = {
  search: {
    adults: undefined,
    checkin: null,
    checkout: null
  }
}

export default compose( withNamespaces('search') )(Listings)
